export enum MandatoryDocumentType {
  CV = 'CV',
  EDUCATION_RECORD = 'EDUCATION_RECORD',
  IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT',
  RIB = 'RIB',
  SS_RECORD = 'SS_RECORD',
}

export enum OptionalDocumentType {
  RESIDENCE_PROOF = 'RESIDENCE_PROOF',
  CRIMINAL_RECORD = 'CRIMINAL_RECORD',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  ONI_CERTIFICATE = 'ONI_CERTIFICATE',
  WORK_CERTIFICATE = 'WORK_CERTIFICATE',
  VACCINATION_RECORD = 'VACCINATION_RECORD',
  COVER_LETTER = 'COVER_LETTER',
  OTHER_DOCUMENT = 'OTHER_DOCUMENT',
}

export type DocumentType = MandatoryDocumentType | OptionalDocumentType
